<template>
	<v-app-bar fixed app height="65" style="width: auto;">
        <!-- >>>  -->
        <v-btn fab small @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)">
            <v-icon v-if="value">
                mdi-view-quilt
            </v-icon>

            <v-icon v-else>
                mdi-dots-vertical
            </v-icon>
        </v-btn>
        <!-- <<<  -->


		<v-toolbar-title class="hidden-sm-and-down">Hotels</v-toolbar-title>


		<!-- >>> Filter TextField -->
		<v-text-field style="margin-left: 60px; margin-top:22px;"
			v-model="filterTerm"
			label="Filter Hotels"
			@keyup="onKeyup_filterHotels">
		</v-text-field>
		<!-- <<< Filter TextField -->


		<span style="margin-left: 30px; margin-top: 31px;"><strong>Shown Hotels: {{ get_Hotels_Filtered.length }}</strong></span>


		<v-spacer></v-spacer>


		<!-- >>> Save Duty Plan Changes Menue (shared) -->
		<sdr-shared-appbar-savedutyplan style="margin-right: 40px;"></sdr-shared-appbar-savedutyplan>
		<!-- <<< Save Duty Plan Changes Menue (shared) -->


        <!-- >>> Sdr-Component, Goodies Menue -->
		<sdr-hotels-appbar-goodiesmenue style="margin-right: 20px;"></sdr-hotels-appbar-goodiesmenue>
        <!-- <<< Sdr-Component, Goodies Menue -->


		<!-- >>> Sdr-Component, Filter Menue -->
		<sdr-hotels-appbar-filtermenue style="margin-left: 40px;"></sdr-hotels-appbar-filtermenue>
		<!-- <<< Sdr-Component, Filter Menue -->


        <!-- >>> Comes later ... -->
		<v-btn icon rounded tile style="margin-left: 40px; margin-right: 0px;">
			<v-icon color="primary">
				mdi-overscan
			</v-icon>
		</v-btn>
        <!-- <<< Comes later ... -->
	</v-app-bar>
</template>

<script>
	import FilterMenue from './FilterMenue.vue';
	import GoodiesMenue from './GoodiesMenue.vue';
	import SaveDutyPlanChangesMenue from '../../../shared/components/core/SaveDutyPlanChangesMenue.vue';

	import { mapActions, mapGetters } from 'vuex';


	export default {
		name: 'HotelsAppBar',

		/* >>> *************************************************************** / /* Components */
		components: {

			'sdr-hotels-appbar-filtermenue': FilterMenue,
			'sdr-hotels-appbar-goodiesmenue': GoodiesMenue,
			'sdr-shared-appbar-savedutyplan': SaveDutyPlanChangesMenue,

		}, // eo components{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Props */
        props: {

            value: {
                type: Boolean,
                default: false
            }

        }, // eo props{}
        /* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Data */
		data: () => ({

			switchCabin: true,
			switchCockpit: true,
			// >>> ------------------------------
			filterTerm: ''

		}), // eo data()
		/* <<< ****************************************************************/




		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_Hotels_Filtered'
			])

		}, // eo computed{}
		/* <<< ****************************************************************/




		/* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([
				'actn_set_filterHotels_filterTerm'
			]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
			/*******************************************************************
            * onKeyup_filterHotels()
            *
            * Desc:
            * Note:
            *
            */
			onKeyup_filterHotels: function() {

				const me = this;


				me.$toc('>>> views/hotels/components/core/AppBar.vue >>> onKeyup_filterHotels');
				this.actn_set_filterHotels_filterTerm(this.filterTerm);

			} // eo function onKeyup_filterHotels()

		} // eo methods{}
		/* <<< ****************************************************************/
	};
</script>

<style scoped>
	.theme--light.v-app-bar.v-toolbar.v-sheet {
		background-color: #FFFFFF;
		border-color: #FFFFFF;
		color: rgba(0, 0, 0, 0.87);
	}

	.v-toolbar__title {
		font-weight: 300;
		color: #555555;
		font-size: 18px;
		margin-bottom: 0px;
	}

	.theme--light.v-btn.v-btn--has-bg {
		background-color: #fff;
	}

    .v-label {
        font-size: 14px !important; /* 16px */
    }
</style>
